import rootStore, { initRootStore } from '../RootStore';
import useSettings from 'hooks/useSettings';
import CustomWeightStore from 'stores/CustomWeightStore';
import { get, isEmpty } from 'lodash/fp';
import { useEffect, useState } from 'react';
import usePreload from './usePreload';
import { initFullStory } from 'utils/FullStoryUtils';
import { E_EVENTS_WORKER_IPC_CODES } from 'components/eventsFeed/EventsWorkerIPC';
import { getApiURL } from 'services/configService';
import TokenExpiryTimer from 'services/TokenExipiryTimer';

const useInit = (
    props: { hasGQPermissions: boolean } = { hasGQPermissions: true }
) => {
    const { settings } = useSettings();

    const { error: preloadError, preloadedData } = usePreload({
        hasGQPermissions: props.hasGQPermissions,
    });
    const [didInitStores, setDidInitStores] = useState<boolean>(false);
    useEffect(() => {
        if (isEmpty(settings)) {
            return;
        }

        initFullStory(settings.username);
        rootStore.UserStore.initUser(settings)
        if (!props.hasGQPermissions) {
            setDidInitStores(true);
            return;
        }
        if (!isEmpty(preloadedData)) {
            initRootStore();

            CustomWeightStore.updateActivePreset(
                settings.activeCustomWeightsPreset
            );

            rootStore.risksStore.setDisabledRisks(
                get('permissions.dimensionResoure', settings),
                get('permissions.clientFacingIndicatorsResource', settings),
                get('permissions.contingentRisksResource', settings)
            );
            rootStore.UserStore.setUscorePermission(
                get('permissions.uscoreResource', settings)
            );

            rootStore.UserStore.setGeoquantFlagsPermission(
                get('permissions.geoquantResource', settings)
            );

            rootStore.countryStore.updateCountries(preloadedData.countries);
            rootStore.risksStore.updateDimensions(preloadedData.dimensions);
            rootStore.risksStore.updateAllDimensions(
                preloadedData.dimensions.allDimensions
            );
            rootStore.risksStore.updateClientFacingIndicators(
                preloadedData.clientFacingIndicators
            );
            rootStore.risksStore.updateContingentRisks(
                preloadedData.contingentRisks
            );
            rootStore.risksStore.initRisksByType();
            rootStore.settingsStore.setActiveGroupId(
                preloadedData.activeGroups.active_group
            );
            rootStore.settingsStore.setActiveGroups(
                preloadedData.activeGroups.groups
            );

            rootStore.eventsFeedStore.eventsHandlerWorker.postMessage({
                code: E_EVENTS_WORKER_IPC_CODES.INIT_DATA,
                baseURL: getApiURL(),
                dimensionsTree: get('dimensions.fullTree', preloadedData),
            });
            TokenExpiryTimer.init();
            setDidInitStores(true);
        }
    }, [preloadedData, settings]);

    return {
        didInitStores,
        preloadError,
        ready: didInitStores && !preloadError,
    };
};

export default useInit;
